// extracted by mini-css-extract-plugin
export default {"sciex-index":"aqsW_LFkwhxjRZvLlukL"};